import styled from "styled-components";

const TableWrapper = styled.div`
  padding-inline: 120px;
  height: var(--table-height);

  .actions-hide {
    cursor: not-allowed;

    .ant-dropdown-trigger {
      cursor: not-allowed;
      pointer-events: none;
    }
    svg {
      color: var(--gray-5);
    }
  }

  .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(
      .ag-cell-range-single-cell
    ) {
  }
`;

export { TableWrapper };
